<template>
<div>
  <div v-if="displayMode.selected === 'tiles'">
    <b-row class="mx-2" align-v="start">
      <div v-if="dynamicCardData.length == 0">
        {{ $t("Webportal.NoDataFound") }}
      </div>
      <b-col  v-for="(market, index) in dynamicCardData"
              :key="index"
              cols="2"
              style="width: 300px; max-width: 300px">
        <Card :colorRange="colorRange"
              :cardData="market"
              @DrilldownAction="loadRetailer"
              :showActionsToTake="false" />
      </b-col>
    </b-row>
  </div>
  <div v-show="displayMode.selected !== 'tiles'" data-bs-theme="light">
    <div style="width: 100%;">
      <CustomDataGrid ref="grid"
                      :rowData="rowData"
                      :columnDefs="cxColumns"
                      :customColumns="customColumns"
                      :defaultColDef="defaultColDef"
                      :pinnedTopRowData="pinnedTopRowData"
                      :theme="theme"
                      :gridOptions="gridOptions"  />
    </div>
  </div>
</div>
</template>

<script>
  import CancelToken from "@/mixins/CancelToken";
  import DashboardService from "@/services/DashboardService";
  import EventBus from "@/services/EventBus.js";

  import Card from "./Card";

  import CheckBoxGrid from '@/components/CX/Grid/CheckBoxGrid';
  import CustomDataGrid from '@/components/CX/Grid/CustomDataGrid';
  import MarketTableColumns from '@/mixins/jlr/MarketTableColumns';

export default {
  mixins: [ CancelToken, MarketTableColumns ],

  components: { 
    Card, CheckBoxGrid, CustomDataGrid
  },

  props: {
    clientId:       { type: Number, default: () => NaN },
    colorRange:     { type: Array,  default: () => [] },
    countryValues:  { type: Object, default: () => {} },
    displayMode:    { type: Object, default: () => undefined },
    overall:        { type: Array,  default: () => [] },
    theme:          { type: String, default: () => 'light' }
  },

  data() {
    return {
      isMounted: false,
      cxColumns: [],
    }
  },

  watch: {
    countryValues: {
      handler(newVal, oldVal) {
        if (newVal.TotalRowCount) {
          this.refreshData(newVal);
        }
      }
    },
  },

  mounted() {
    // console.trace('ClientSelection.getClientSettings initializes the three times load issue');
    if (this.countryValues) {
      this.refreshData(this.countryValues);
    }
    EventBus.$on("showDetail", this.loadRetailer);
    EventBus.$on("show-market-details-clicked", this.loadRetailer);
    this.isMounted = true;
  },

  beforeDestroy() {
    this.$store.commit('markets', this.customColumns.active);
    EventBus.$off("showDetail", this.loadRetailer);
    EventBus.$off("show-market-details-clicked", this.loadRetailer);
  },

  computed: {
    dynamicCardData() {
      if (!this.countryValues.AggregatedData) 
        return [];

      return this.countryValues.AggregatedData
        .filter((data) => data.CountryName)
        .map((data) => {
          return {
            Title: data.CountryName,
            Subtitle: "",
            Image: data.CountryId,
            Value: data.CXScore,
            NumberOfDealers: data.NumberOfDealers,
            ActionsToTake:
              (data?.ExplorationActionsToTake || 0) +
              (data?.KpiActionsToTake || 0) +
              (data?.AFSActionsToTake || 0),
            Drilldown: data.CountryId,
          };
        });
    },

    dynamicColumnDefs() {
      // Setup standard columns
      let items = [...this.columnDefs].map(this.setupLocalColumn);
      return items;

      if (this.isMounted && 
          this.cxColumns && 
          this.cxColumns.length > 0) {
        
        for (let i = 0; i < this.customColumns.items.length; i++) {
          const element = this.customColumns.items[i];
          // if (element.isHeader) {
          //   continue;
          // }
          if (!this.customColumns.active.includes(element.key)) {
            element.hide = false;
          }
          items.push(element)
        }
        // items.push(...this.customColumns.active.map(x => { return this.mixinGetColumn(x) } )
        //   .filter(x => x !== undefined));
        this.$store.commit('markets', this.customColumns.active);
      }
      return items;
    }
  },

  methods: {
    refreshData(values) {
      this.tableCancelToken = this.initCancelToken(this.tableCancelToken);
      this.getCxTableStructure(
        this.tableCancelToken, 
        { clientId: this.clientId, tableId: 'market' }
      );

      this.RowCount = values?.TotalRowCount;
      this.rowData = values?.AggregatedData;

      this.pinnedTopRowData = this.applyTopLineFix(_.last(values?.MarketData), true);
    },

    loadRetailer(countryId, countryOverall = undefined) {
      this.$emit("drilldownToRetailer", countryId, countryOverall);
    },
  },
};
</script>

<style scoped>
  .msm-card {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }

  .msm-card-title {
    padding-bottom: 0px;
    padding-top: 0px;
    border-bottom: 1px solid lightgray;
    font-size: 1.25rem;
    font-weight: 500;
  }

  .card-footer {
    padding: 0px;
  }
</style>
